import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate, useParams } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import PrivateRoute from "components/PrivateRoute";

// Redirect helpers for old URLs with params
const RedirectToEditor = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/editor`} replace />;
};
const RedirectToPreview = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/preview`} replace />;
};
const RedirectToSettings = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/settings`} replace />;
};
import NotFound from "pages/NotFound";
import Login from './pages/login';
import Register from './pages/register';
import Dashboard from './pages/dashboard';
import TemplateSelection from './pages/template-selection';
import PageBuilder from './pages/page-builder';
import PreviewMode from './pages/preview-mode';
import SiteSettings from './pages/site-settings';
import PublicPreview from './pages/public-preview';
import Sandbox from './pages/sandbox';
import Account from './pages/account';

// Wrapper for subdomain mode — renders PublicPreview directly
const SubdomainPublicPreview = () => {
  // Новый flow: window.__SUBDOMAIN__ (без lookup в Cloud Function)
  const subdomain = window.__SUBDOMAIN__;
  // Старый flow: window.__SUBDOMAIN_PROJECT_ID__ (для кастомных доменов)
  const projectId = window.__SUBDOMAIN_PROJECT_ID__;

  return <PublicPreview subdomain={subdomain} subdomainProjectId={projectId} />;
};

const Routes = () => {
  // If accessed via subdomain or custom domain, render PublicPreview directly (clean URL)
  if (typeof window !== 'undefined' && (window.__SUBDOMAIN__ || window.__SUBDOMAIN_PROJECT_ID__)) {
    return (
      <BrowserRouter>
        <ErrorBoundary>
          <SubdomainPublicPreview />
        </ErrorBoundary>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Sandbox - demo without auth */}
        <Route path="/sandbox" element={<Sandbox />} />

        {/* Published site - public */}
        <Route path="/p/:projectId" element={<PublicPreview />} />

        {/* Protected routes */}
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/template-selection" element={<PrivateRoute><TemplateSelection /></PrivateRoute>} />
        <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />

        {/* Project routes */}
        <Route path="/projects/:projectId/editor" element={<PrivateRoute><PageBuilder /></PrivateRoute>} />
        <Route path="/projects/:projectId/preview" element={<PrivateRoute><PreviewMode /></PrivateRoute>} />
        <Route path="/projects/:projectId/settings" element={<PrivateRoute><SiteSettings /></PrivateRoute>} />

        {/* Redirects for old URLs */}
        <Route path="/page-builder/:projectId" element={<RedirectToEditor />} />
        <Route path="/page-builder" element={<Navigate to="/sandbox" replace />} />
        <Route path="/preview-mode/:projectId" element={<RedirectToPreview />} />
        <Route path="/preview-mode" element={<Navigate to="/dashboard" replace />} />
        <Route path="/site-settings/:projectId" element={<RedirectToSettings />} />
        <Route path="/site-settings" element={<Navigate to="/dashboard" replace />} />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
